import { Link } from "shared/components/Link";
import { AppRoute } from "../../constants";
import Layout from "../../components/mainPage/Layout";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    Приложение для мобильных устройств
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        NPT Mobile представляет собой мобильную версию клиента <Link className="text-links" to={`/${AppRoute.DesktopApplication}`}>SCADA NPT Expert</Link> для устройств на ОС Android (смартфоны, планшеты и т.п).
                    </p>
                    <p>
                        Клиент SCADA для устройств на ОС Android используется для обеспечения удаленного доступа к данным и управления промышленными процессами с мобильных устройств. Это особенно полезно для специалистов, которым необходимо контролировать системы вне стационарного рабочего места.
                    </p>

                    <p>Основные задачи, для которых применяется мобильный клиент SCADA:</p>

                    <ul className="mb-4 description__list">

                        <li className="mb-1 description__number-li">Удаленный мониторинг процессов
                            <ul>
                                <li className=" ">Отслеживание параметров технологических процессов в реальном времени (температура, давление, уровень и т.д.).</li>
                                <li className=" ">Получение данных с датчиков, контроллеров и другого оборудования</li>
                            </ul>
                        </li>

                        <li className="mb-1 description__number-li">Управление оборудованием
                            <ul>
                                <li>Удаленное управление устройствами (включение/выключение, изменение настроек).</li>
                                <li>Быстрое реагирование на аварийные ситуации, даже если оператор находится вне диспетчерской.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li">Получение уведомлений и аварийных сигналов
                            <ul>
                                <li className=" ">Оповещения о нештатных ситуациях (например, утечки, перегрузки, сбои).</li>
                                <li className=" ">Возможность мгновенного реагирования на аварии через мобильное устройство.</li>
                            </ul>
                        </li>

                        <li className="mb-1 description__number-li">Анализ данных и отчетность
                            <ul>
                                <li className=" ">Просмотр исторических данных и трендов.</li>
                                <li className=" ">Формирование отчетов и анализ эффективности процессов.</li>
                            </ul>
                        </li>

                        <li className="mb-1 description__number-li">Диагностика и техническое обслуживание
                            <ul>
                                <li className=" ">Удаленная диагностика оборудования.</li>
                                <li className=" ">Контроль состояния систем для планирования технического обслуживания.</li>
                            </ul>
                        </li>

                        <li className="mb-1 description__number-li">Работа в полевых условиях
                            <ul>
                                <li className=" ">Мониторинг и управление удаленными объектами (например, насосные станции, ветряные электростанции, нефтяные вышки).</li>
                                <li className=" ">Использование мобильного устройства для работы на объектах, где нет стационарных рабочих мест.</li>
                            </ul>
                        </li>

                        <li className="mb-1 description__number-li">Повышение мобильности персонала
                            <ul>
                                <li className=" ">Освобождение операторов от необходимости постоянно находиться в диспетчерской.</li>
                                <li className=" ">Возможность контроля процессов из любой точки, где есть доступ к сети.</li>
                            </ul>
                        </li>

                        <li className="mb-1 description__number-li">Обучение и симуляция
                            <ul>
                                <li className=" ">Использование мобильного клиента для обучения персонала.</li>
                                <li className=" ">Проведение симуляций и тренировок на мобильных устройствах.</li>
                            </ul>
                        </li>

                        <li className="mb-1 description__number-li">Оптимизация работы
                            <ul>
                                <li className=" ">Ускорение принятия решений за счет мгновенного доступа к данным.</li>
                                <li className=" ">Упрощение взаимодействия между операторами и инженерами.</li>
                            </ul>
                        </li>

                    </ul>
                    <p>
                        <b>Примеры применения:</b>
                    </p>
                    <div><b>Энергетика:</b> Мониторинг состояния энергосетей, управление подстанциями.</div>
                    <div><b>Нефтегазовая промышленность:</b> Контроль добычи и транспортировки углеводородов.</div>
                    <div><b>Водоснабжение и канализация:</b> Управление насосными станциями и очистными сооружениями.</div>
                    <div><b>Транспорт:</b> Мониторинг светофоров, управление инфраструктурой.</div>
                    <div><b>Производство:</b> Контроль конвейерных линий и станков.</div>
                </div>
            </div>
        </div>
    </Layout>
}

export const meta = {
    title: 'Приложение для мобильных устройств',
    description: 'NPT Mobile представляет собой мобильную версию клиента SCADA NPT Expert для устройств на ОС Android (смартфоны, планшеты и т.п).'
}